import { ShieldCheck, ExternalLink, Clock, AlertTriangle } from "lucide-react";

/* "Trust strip" rendered on data-heavy airport pages. Makes sourcing and
   last-verified dates visible to the user and signals that operational facts
   should be confirmed with the airline/airport before travel. */
export default function TrustStrip({
  sources = [],
  lastVerified,
  changes = "Terminal assignments, airline relationships, parking fees and transport schedules can change.",
  className = "",
  testid = "trust-strip",
}) {
  const fmt = (iso) => {
    if (!iso) return "—";
    try {
      return new Date(iso).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
    } catch {
      return iso;
    }
  };

  return (
    <aside
      data-testid={testid}
      className={`border border-emerald-200/80 bg-emerald-50/50 rounded-2xl px-4 py-3 text-[12px] text-emerald-900 ${className}`}
    >
      <div className="flex flex-wrap items-center gap-x-5 gap-y-1.5">
        <span className="inline-flex items-center gap-1.5 font-800 text-emerald-800">
          <ShieldCheck className="w-4 h-4" /> Verified aviation record
        </span>
        {lastVerified && (
          <span className="inline-flex items-center gap-1.5 text-emerald-800" data-testid={`${testid}-verified`}>
            <Clock className="w-3.5 h-3.5" /> Last verified <b className="font-700">{fmt(lastVerified)}</b>
          </span>
        )}
        {sources.length > 0 && (
          <span className="inline-flex items-center gap-1.5 flex-wrap">
            <span className="font-700 text-emerald-800">Sources:</span>
            {sources.map((s, i) => (
              <a
                key={`${s.url}-${i}`}
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`${testid}-source-${i}`}
                className="inline-flex items-center gap-0.5 text-blue-700 hover:underline font-700"
              >
                {s.label || s.org || s.url} <ExternalLink className="w-3 h-3" />
              </a>
            ))}
          </span>
        )}
      </div>
      <p className="mt-1.5 text-emerald-900/80 inline-flex items-start gap-1.5">
        <AlertTriangle className="w-3.5 h-3.5 mt-0.5 shrink-0 text-amber-600" />
        <span>{changes} Always confirm critical details with your airline or the airport operator before you travel.</span>
      </p>
    </aside>
  );
}
